import DynamicLayout from './DynamicLayout';
export default DynamicLayout;



// WEBPACK FOOTER //
// ./src/client/js/view/routes/DynamicLayout/index.js